import { render, staticRenderFns } from "./ReportBuilderV2.vue?vue&type=template&id=3b74ff22&scoped=true"
import script from "./ReportBuilderV2.vue?vue&type=script&lang=js"
export * from "./ReportBuilderV2.vue?vue&type=script&lang=js"
import style0 from "./ReportBuilderV2.vue?vue&type=style&index=0&id=3b74ff22&prod&lang=scss"
import style1 from "./ReportBuilderV2.vue?vue&type=style&index=1&id=3b74ff22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b74ff22",
  null
  
)

export default component.exports